import React from 'react';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';
import { convertTimeToDecimal } from '../../../action/timeCalculation.jsx';
import moment from 'moment';

const ExcelExport = ({ data, fileName, filterDate }) => {
    const headers = [
        'S.No', 'Employee Name', 'Project Name', 'Meter Name', 'Billable Hours', 'Task Description'
    ];

    const exportToExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Timelog');

        // To apply border style
        const applyBorder = (cell) => {
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        };

        // Define color and pattern for header
        const headerColor = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '8ea5e8' }
        };

        // Add timelog date
        worksheet.mergeCells('A1:F1');
        const headerTimeRow = worksheet.getCell('A1');
        headerTimeRow.value = moment(filterDate).format("Do MMMM YYYY");
        headerTimeRow.font = { size: 13, bold: true };
        headerTimeRow.height = 30;

        // Add header row with styling
        const headerRow = worksheet.addRow(headers);
        headerRow.font = { size: 10, bold: true };
        headerRow.alignment = { horizontal: 'center' };
        headerRow.height = 30;

        // Apply header color to columns A-F
        for (let i = 1; i <= 6; i++) {
            const cell = worksheet.getCell(2, i);
            cell.fill = headerColor;
            applyBorder(cell);
        }

        if (data.filter(emp => emp.channel === 'Upwork' && !emp.deleted_at && emp.billable_time ).length === 0) {
            worksheet.mergeCells('A3:F3');
            const cell = worksheet.getCell('A3');
            cell.value = 'No Data Found';
            cell.alignment = { horizontal: 'center' };
            applyBorder(cell);
        } 
        else {
            let totalBillableHours = 0;

            const mappedData = data.filter(emp => emp.channel === 'Upwork' && !emp.deleted_at && emp.billable_time)
                                    .sort((a, b) => a.user_name.localeCompare(b.user_name))
                                    .map((item, index) => {
                                        const hours = convertTimeToDecimal(item.billable_time);
                                        totalBillableHours += hours;

                                        return [
                                            index + 1,
                                            item.user_name || '',
                                            item.project || '',
                                            item.meter || '',
                                            item.billable_time || '',
                                            item.billable_description || ''
                                        ];
                                    });
            
            mappedData.forEach(row => {
                const excelRow = worksheet.addRow(row);
                excelRow.eachCell({ includeEmpty: true }, cell => {
                    applyBorder(cell);
                });
            });

            // Add Total Hours Row
            const totalRow = worksheet.addRow(['', '', '', 'Total Hours', totalBillableHours, '']);
            totalRow.font = { bold: true };
            totalRow.eachCell({ includeEmpty: true }, cell => {
                applyBorder(cell);
            });
        }

        // Auto adjust column widths
        worksheet.columns.forEach((column) => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, cell => {
                if (cell.value && cell.value.toString().length > maxLength) {
                    maxLength = cell.value.toString().length;
                }
            });
            column.width = maxLength + 2;
        });

        // Save the workbook
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        saveAs(blob, `${fileName}.xlsx`);
    };

    return (
        <button className="btn btn-primary" onClick={exportToExcel}>
            <i className="fa fa-file-excel"></i> &nbsp; Export to Excel</button>
    );
}

export default ExcelExport;
